import React from 'react';

const Forestry = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Forestry</h2>
                <p>
                    Revolutionize forest management with our specialized LiDAR services. Our technology provides detailed 3D models of forest canopy, understory, and terrain, enabling precision forestry practices that maximize yield while promoting sustainability.
                </p>
                <p>
                    From estimating timber volume and biomass to monitoring forest health and planning harvests, our data helps forestry professionals make informed decisions about resource management, conservation, and fire prevention.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Timber Volume Estimation</span>
                    <span className="feature-item">Biomass Calculation</span>
                    <span className="feature-item">Forest Health Monitoring</span>
                    <span className="feature-item">Fire Risk Assessment</span>
                    <span className="feature-item">Harvest Planning</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/forestry.png" alt="Forestry LiDAR Application" />
            </div>
        </div>
    );
};

export default Forestry;
